import GoalIndexRoute from 'cio/pods/base/setup/goal/index/route';

export default class IndexRoute extends GoalIndexRoute {
  templateName = 'base/setup/goal/index';
}
